/* HTTP service */

import axios from "axios";
import Settings from "../services/settings.service";
import Errors from "../services/errors.service";


const HTTPOcr = axios.create({
	baseURL: Settings.ocr_url,
	headers: {
		"Accept": "application/json, text/plain, */*",
		"content-type": "application/json",
	}
});


HTTPOcr.interceptors.response.use(undefined, function (error) {
	Errors.handleError(error);
	throw error;
});


export default HTTPOcr;